<div class="bloco-unico comprovantes">
  <h3 class="uppercase">Comprovante Digitalizado</h3>
  <hr>
  <div *ngIf="!pedido?.comprovantes || pedido?.comprovantes.length === 0" style="min-height: 100px"
    class="d-flex justify-content-center align-items-center">
    <strong>Não há informação a ser exibida!</strong>
  </div>
  <div *ngIf="pedido?.comprovantes && pedido?.comprovantes.length > 0" class="imagem">
    <div *ngFor="let comprovante of pedido?.comprovantes">
      <img class="comprovante" [src]="comprovante.comprovante">
      <br>
      <ul>
        <li>Data de inclusão: {{comprovante.dataInclusao | date: 'dd/MM/yyyy HH:mm:ss'}}</li>
        <li>Latitude: {{comprovante.latitude}}</li>
        <li>Longitude: {{comprovante.longitude}}</li>
        <li>nomeImagem: {{comprovante.nomeImagem}}</li>
      </ul>
    </div>
  </div>
</div>
